import React, { createContext, useCallback, useEffect, useState } from "react";
import clinicaConfig from "../clinicaConfig.js";

export const ShopContext = createContext(null);

const API_BASE_URL = clinicaConfig.REACT_APP_API_BASE_URL || "http://localhost:4000";

function loadCart() {
  try {
    const stored = localStorage.getItem("cartItems");
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    localStorage.removeItem("cartItems");
    return {};
  }
}

const ShopContextProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [cartItems, setCartItems] = useState(loadCart);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const fetchProducts = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(`${API_BASE_URL}/public/products`, {
        headers: {
          "X-Client-Domain": window.location.hostname,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || "Falha ao buscar os exames.");
      }
      setProducts(Array.isArray(data.products) ? data.products : []);
    } catch (requestError) {
      setError(requestError.message || "Nao foi possivel carregar os exames.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  const addToCart = (itemId) => {
    setCartItems((current) => ({
      ...current,
      [itemId]: (current[itemId] || 0) + 1,
    }));
  };

  const removeFromCart = (itemId) => {
    setCartItems((current) => ({
      ...current,
      [itemId]: Math.max(0, (current[itemId] || 0) - 1),
    }));
  };

  const clearCart = () => setCartItems({});

  const getTotalCartItems = () =>
    Object.values(cartItems).reduce((total, quantity) => total + Math.max(0, Number(quantity) || 0), 0);

  const getTotalCartAmount = () =>
    Object.entries(cartItems).reduce((total, [itemId, quantity]) => {
      const product = products.find((item) => String(item.id || item._id) === String(itemId));
      if (!product) return total;
      return total + (Number(quantity) || 0) * (Number(product.old_price) || 0);
    }, 0);

  const contextValue = {
    allproducts: products,
    products,
    loading,
    error,
    getTotalCartItems,
    cartItems,
    addToCart,
    removeFromCart,
    getTotalCartAmount,
    clearCart,
  };

  return <ShopContext.Provider value={contextValue}>{children}</ShopContext.Provider>;
};

export default ShopContextProvider;
